import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import BootstrapTable from "react-bootstrap-table-next";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import Col from "react-bootstrap/Col";
import Container from "react-bootstrap/Container";
import Modal from "react-bootstrap/Modal";
import Row from "react-bootstrap/Row";
import "../../../../utils/Css/contractlist.css";
import paginationFactory from "react-bootstrap-table2-paginator";
import ToolkitProvider from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import {
  deleteContract,
  getAllContracts,
  getContractTypeNames,
  getPostNames,
  updateContract,
} from "../../../../services/RHService/ContractService";
import moment from "moment";
import getCurrentUserId from "../../../../reduxSaga/sagas/requests/currentUserId";
import withLoader from "../../../../components/layouts/WithLoader";
import { toast } from "react-toastify";
import api from "../../../../services/api";

const ContractList = ({ startLoading, stopLoading }) => {
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const [contracts, setContracts] = useState([]);
  const [selectedContract, setSelectedContract] = useState(null);
  const [contracttypeNames, setContracttypeNames] = useState([]);
  const [postNames, setPostNames] = useState([]);
  const [uploadedData, setUploadedData] = useState(null); // Track file
  const [isUploading, setIsUploading] = useState(false); // Track upload state
  const [notAdded, setNotAdded] = useState([]);

  const handleShow = (contrat) => {
    setSelectedContract(contrat);
    setShow(true);
  };
  useEffect(() => {
    fetchData();
  }, []);
  //Tout les contrats
  const fetchData = () => {
    startLoading();
    getAllContracts(getCurrentUserId())
      .then((response) => {
        console.log(response);
        setContracts(response.data?.success);
      })
      .catch((error) => {
        console.log("error", error);
      })
      .finally(() => {
        stopLoading();
      });
  };
  //Tout les contrats
  useEffect(() => {
    getContractTypeNames(getCurrentUserId())
      .then((names) => {
        setContracttypeNames(names.data?.success);
      })
      .catch((error) => {
        console.log("error", error);
      });
  }, []); // Empty dependency array means this effect will run once after the initial render

  useEffect(() => {
    const fetchPostNames = async () => {
      try {
        const user = JSON.parse(localStorage.getItem("user"));
        const userId = user?.token?.idUser;

        const names = await getPostNames(userId);
        setPostNames(names.data?.success);
      } catch (error) {
        console.error("Error fetching post names:", error);
      }
    };

    fetchPostNames();
  }, []);
  //les post et type de contrat pour formulaire de modification

  //delete
  const handleDelete = async (contractId) => {
    await deleteContract(contractId, setContracts);
  };
  //Les colonnes de tableau
  const columns = [
    {
      dataField: "id_empl",
      text: "Mat",
      formatter: (cell, row, rowIndex, formatExtraData) => {
        return rowIndex + 1;
      },
    },
    {
      dataField: "firstname",
      text: "Personnel",
      formatter: (cell, row) => `${row.firstname} ${row.lastname}`,
    },
    { dataField: "contractType", text: "Contrat" },
    {
      dataField: "nomPost",
      text: "Post",
      render: (value) => (value ? value : "-"),
    },

    { dataField: "date_deb", text: "Date D." },
    { dataField: "date_fin", text: "Date F." },
    {
      dataField: "mode_paiement",
      text: "M. Paiement",
      formatter: (cell, row) => {
        if (row.mode_paiement === "espéce") {
          return "Espéce";
        } else if (row.mode_paiement === "VIREMENT") {
          return "Virement";
        } else {
          return "Chéque";
        }
      },
    },
    {
      dataField: "rib",
      text: "Rib",
      formatter: (cell, row) => {
        if (row.mode_paiement === "espéce") {
          return <div style={{ textAlign: "center" }}>-</div>;
        } else {
          return <div style={{ textAlign: "center" }}>{cell}</div>;
        }
      },
    },
    { dataField: "montant_brut", text: "Salaire B." },
    {
      dataField: "actions",
      text: "Actions",
      headerStyle: { width: "170px" },
      csvExport: false,
      formatter: (cell, row) => {
        return (
          <div className="center" style={{ display: "flex" }}>
            <Button
              style={{
                "background-color": "#000",
                color: "white",
                "border-color": "transparent",
                "border-radius": "0px",
              }}
              onClick={() => {
                handleShow(row);
              }}
            >
              <i class="fa-solid fa-pencil"></i>
            </Button>
            <Link to={`/contractDetail?idContract=${row.idContract}`}>
              <Button
                className="mx-1"
                style={{
                  "background-color": "#696969",
                  "border-color": "transparent",
                  "border-radius": "0px",
                }}
              >
                <i
                  class="fa-solid fa-eye eye-icon m-1"
                  style={{ color: "white" }}
                ></i>
              </Button>
            </Link>

            <Button
              style={{
                "background-color": "#cc0000",
                color: "white",
                "border-color": "transparent",
                "border-radius": "0px",
              }}
              onClick={() => {
                handleDelete(row.idContract);
              }}
            >
              <i class="fa-solid fa-trash-can"></i>
            </Button>
          </div>
        );
      },
    },
  ];
  //les options de pagination
  const options = {
    sizePerPage: 5,
    hideSizePerPage: true,
    hidePageListOnlyOnePage: true,
    paginationPosition: "bottom",
  };
  const onTelechargerModel = () => {
    const headers = [
      ["CIN", "Salaire net", "Salaire brut"], // Header row
      // ["Value1", "Value2", "Value3"],   // Example row of data
    ];
    const workbook = XLSX.utils.book_new();
    const worksheet = XLSX.utils.aoa_to_sheet(headers);

    // Add green background styling to headers
    const range = XLSX.utils.decode_range(worksheet["!ref"]);
    for (let C = range.s.c; C <= range.e.c; ++C) {
      const cellAddress = XLSX.utils.encode_cell({ r: 0, c: C });
      if (!worksheet[cellAddress]) continue;
      worksheet[cellAddress].s = {
        fill: { fgColor: { rgb: "00FF00" } }, // Green background
        font: { bold: true, color: { rgb: "000000" } }, // Black bold text
      };
    }

    // Append worksheet to workbook
    XLSX.utils.book_append_sheet(workbook, worksheet, "Model");

    // Save file as a downloadable Excel file
    const fileBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
    saveAs(new Blob([fileBuffer], { type: "application/octet-stream" }), "model.xlsx");
  };
  // filtrage par date Debut, date  fin , mode de paiemnet , post , type de contrat et assurance vie
  const [formData, setFormData] = useState({});
  const handleInputChange = (event) => {
    const target = event.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const name = target.name;
    setFormData({
      ...formData,
      [name]: value,
    });
  };


  const filteredData = contracts.filter((contrat) => {
    const idContratType = contrat.idContractType
      ? contrat.idContractType.toString()
      : null;
    const idPost = contrat.idPost ? contrat.idPost.toString() : null;

    if (
      (formData.dateDeb &&
        new Date(contrat.date_deb) < new Date(formData.dateDeb)) ||
      (formData.dateFin &&
        new Date(contrat.date_fin) > new Date(formData.dateFin)) ||
      (formData.mode_paiement &&
        contrat.mode_paiement !== formData.mode_paiement &&
        formData.mode_paiement !== "mP")
    ) {
      return false;
    }

    if (
      (formData.idContractType &&
        idContratType !== formData.idContractType &&
        formData.idContractType !== "contrat") ||
      (formData.idPost &&
        idPost !== formData.idPost &&
        formData.idPost !== "post")
    ) {
      return false;
    }

    return true;
  });

  // filtrage par date Debut, date  fin , mode de paiemnet , post , type de contrat et assurance vie
  //update
  const handleUpdate = async (event) => {
    event.preventDefault();
    // Convert date format to "dd/MM/yyyy"
    const { date_deb, date_fin, ...otherFormData } = selectedContract;
    const formattedFormData = {
      ...otherFormData,
      date_deb: moment(selectedContract.date_deb).format("YYYY-MM-DD"),
      date_fin: moment(selectedContract.date_fin).format("YYYY-MM-DD"),
    };

    try {
      await updateContract(formattedFormData.idContract, formattedFormData);
      fetchData();
      handleClose();
    } catch (error) {
      alert(error.message);
    }
  };
    const handleFileUpload = (e) => {
    const file = e.target.files[0]; // Get the first file from the input
    if (file) {
      setUploadedData(file); // Store the file in state
    }
  };



    const uploadExcelFileToServer = (file) => {
      if (!file) {
        toast.error("Aucun fichier sélectionné");
        return Promise.reject(new Error("No file provided"));
      }
      const formData = new FormData();
      formData.append("file", file);
      startLoading()
      const url = `/rh/contracts/updateSalaryNetOrBrutByExcel/${getCurrentUserId()}`;
  
      return api
        .post(url, formData, {
          headers: {
            "Content-Type": "multipart/form-data",
            Accept: "application/json",
          },
        })
        .then((response) => {
          toast.success("Fichier téléchargé avec succès");
          stopLoading();
          return response;
        })
        .catch((error) => {
          toast.error("Erreur lors du téléchargement du fichier");
          stopLoading();
          throw error;
        });
    };
   const handleAjouter = () => {
    if (uploadedData && !isUploading) {
      setIsUploading(true); // Set uploading state to true
      uploadExcelFileToServer(uploadedData)
        .then((response) => {
          console.log("Upload successful", response);
          setNotAdded(response.data["not addedd"]);
        })
        .catch((error) => {
          console.error("Upload error", error);
        })
        .finally(() => {
          setIsUploading(false); // Reset uploading state after process finishes
        });
    } else {
      console.error("No file selected for upload or upload already in progress.");
    }
  };
  return (
    <div class="content-wrapper" style={{ marginTop: "0", padding: "0" }}>
     <br/>
      <Modal show={show} onHide={handleClose} size="xl">
        <Modal.Header closeButton>
          <Modal.Title>Modifier les informations</Modal.Title>
        </Modal.Header>
        <Modal.Body className="show-grid">
          <Form onSubmit={handleUpdate}>
            <Container>
              <Row>
                <Col xs={12} md={6}>
                  <Form.Group className="form-group">
                    <Form.Label>Nom d'employé</Form.Label>
                    <input
                      type="text"
                      className="form-control form-control-border"
                      name="idPersonnel"
                      placeholder={
                        selectedContract
                          ? selectedContract.firstname +
                          " " +
                          selectedContract.lastname
                          : ""
                      }
                      value={
                        selectedContract
                          ? selectedContract.firstname +
                          " " +
                          selectedContract.lastname
                          : ""
                      }
                      onChange={(e) =>
                        setSelectedContract({
                          ...selectedContract,
                          idPersonnel: e.target.placeholder,
                        })
                      }
                      disabled
                    />
                  </Form.Group>
                  <div className="form-group">
                    <label>Type de contrat </label>
                    <select
                      className="custom-select form-control-border"
                      name="idContractType"
                      onChange={(e) =>
                        setSelectedContract({
                          ...selectedContract,
                          idContractType: e.target.value,
                        })
                      }
                    >
                      <option value="typecontrat" disabled>
                        {selectedContract ? selectedContract.contractType : ""}
                      </option>
                      {contracttypeNames.map((contracttypeName) => (
                        <option
                          key={contracttypeName.id}
                          value={contracttypeName.id}
                        >
                          {contracttypeName.nomContrat}
                        </option>
                      ))}
                    </select>
                  </div>

                  <div className="form-group">
                    <label>Date de début:</label>
                    <div className="input-group ">
                      <input
                        type="date"
                        name="date_deb"
                        value={
                          selectedContract ? selectedContract.date_deb : ""
                        }
                        onChange={(e) =>
                          setSelectedContract({
                            ...selectedContract,
                            date_deb: e.target.value,
                          })
                        }
                        className="form-control form-control-border "
                      />
                    </div>
                  </div>

                  <div className="form-group">
                    <label>Date de fin:</label>
                    <div className="input-group date">
                      <input
                        type="date"
                        name="date_fin"
                        defaultValue={
                          selectedContract ? selectedContract.date_fin : ""
                        }
                        onChange={(e) =>
                          setSelectedContract({
                            ...selectedContract,
                            date_fin: e.target.value,
                          })
                        }
                        className="form-control form-control-border "
                      />
                    </div>
                  </div>
                  <div className="form-group">
                    <label for="exampleSelectBorder">Mode de paiment </label>
                    <select
                      className="custom-select form-control-border"
                      name="mode_paiement"
                      value={
                        selectedContract ? selectedContract.mode_paiement : ""
                      }
                      onChange={(e) =>
                        setSelectedContract({
                          ...selectedContract,
                          mode_paiement: e.target.value,
                        })
                      }
                    >
                      <option value="ESPECE">Espéce</option>
                            <option value="CHEQUE">Chéque</option>
                            <option value="VIREMENT">
                              Virement
                            </option>
                    </select>
                  </div>

                  {selectedContract &&
                    ((selectedContract.mode_paiement === "CHEQUE" && (
                      <div className="form-group">
                        <label>RIB</label>
                        <input
                          type="text"
                          name="rib"
                          value={selectedContract.rib}
                          onChange={(e) =>
                            setSelectedContract({
                              ...selectedContract,
                              rib: e.target.value,
                            })
                          }
                          className="form-control form-control-border"
                          placeholder="RIB"
                        />
                      </div>
                    )) ||
                      (selectedContract.mode_paiement ===
                        "VIREMENT" && (
                          <div>
                            <label className="form-group">
                              <label>RIB </label>
                              <input
                                type="text"
                                name="rib"
                                value={selectedContract.rib}
                                onChange={(e) =>
                                  setSelectedContract({
                                    ...selectedContract,
                                    rib: e.target.value,
                                  })
                                }
                                className="form-control form-control-border"
                                placeholder="RIB"
                              />
                            </label>
                          </div>
                        )))}
                </Col>
                <Col xs={12} md={6}>
                  <div className="form-group">
                    <label>Poste </label>

                    <select
                      className="custom-select form-control-border"
                      name="idPost"
                      onChange={(e) =>
                        setSelectedContract({
                          ...selectedContract,
                          idPost: e.target.value,
                        })
                      }
                    >
                      <option value="post" disabled>
                        {selectedContract ? selectedContract.nomPost : ""}
                      </option>

                      {postNames.map((postName) => (
                        <option key={postName.id} value={postName.id}>
                          {postName.nomPost}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="form-group">
                    <label>Montant brut mensuel</label>
                    <input
                      type="text"
                      className="form-control form-control-border"
                      name="montant_brut"
                      value={
                        selectedContract ? selectedContract.montant_brut : ""
                      }
                      onChange={(e) =>
                        setSelectedContract({
                          ...selectedContract,
                          montant_brut: e.target.value,
                        })
                      }
                      placeholder="Montant"
                    />
                  </div>
                  <Form.Group
                    className="mb-3"
                    controlId="exampleForm.ControlInput1"
                  >
                    <Form.Label>Nom de diplome</Form.Label>
                    <Form.Control
                      className="form-control form-control-border"
                      type="text"
                      name="nom_diplome"
                      value={
                        selectedContract ? selectedContract.nom_diplome : ""
                      }
                      placeholder="Nom de diplome"
                      onChange={(e) =>
                        setSelectedContract({
                          ...selectedContract,
                          nom_diplome: e.target.value,
                        })
                      }
                      autoFocus
                    />
                  </Form.Group>
                  <div className="form-group">
                    <label for="exampleInputPassword1">Niveau de diplome</label>
                    <select
                      className="custom-select form-control-border"
                      name="nivaux_diplome"
                      onChange={(e) =>
                        setSelectedContract({
                          ...selectedContract,
                          nivaux_diplome: e.target.value,
                        })
                      }
                    >
                      <option value="nivaux_diplome" disabled>
                        {selectedContract
                          ? selectedContract.nivaux_diplome
                          : ""}
                      </option>

                      <option>Diplôme non validé</option>
                      <option>Bac Professionnel, BEP, CAP</option>
                      <option>Doctorat, PHD</option>
                      <option>Ingénieur</option>
                      <option>Licence, Bac + 3</option>
                      <option>Lycée, Niveau Bac</option>
                      <option>Bac non validé</option>
                      <option>Etudiant</option>
                      <option>DUT, BTS, Bac + 2</option>
                      <option>Maîtrise, IEP, IUP, Bac + 4</option>
                      <option>
                        DESS, DEA, Master, Bac + 5, Grandes Ecoles
                      </option>
                    </select>
                  </div>

                  <div className="form-group">
                    <label>Nombre initiale de congé </label>
                    <div className="input-group">
                      <input
                        type="number"
                        name="nb_jrs_cong"
                        value={
                          selectedContract ? selectedContract.nb_jrs_cong : ""
                        }
                        onChange={(e) =>
                          setSelectedContract({
                            ...selectedContract,
                            nb_jrs_cong: e.target.value,
                          })
                        }
                        className="form-control form-control-border"
                        min="0"
                        max="100"
                        step="1"
                        placeholder="Nombre initiale de congé "
                      />
                    </div>
                  </div>
                </Col>
              </Row>
            </Container>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Fermer
          </Button>
          <Button variant="dark" onClick={handleUpdate}>
            Modifier
          </Button>
        </Modal.Footer>
      </Modal>

      <section className="content ">
        <div class="container-fluid">
          <div class="card card-dark">
            <div class="card-body">
              <h5 class="card-title">Etablir un nouveau contrat</h5>

              <Link to="/addContract">
                <button class="btn btn-dark  float-right">
                  <i class="fas fa-plus"></i>
                </button>
              </Link>
            </div>
          </div>
        </div>
      </section>
        <section className="content">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-12">
              <div className="card card-dark">
                <div className="card-footer">
                  <h4>Modifier les salaires</h4>
                </div>
                <div className="card-body my-0 py-0">
                  <p>Si la valeur de la colonne n'est pas présente merci de mettre - </p>
                   <button className="btn btn-dark float-right" onClick={onTelechargerModel}>
                    <i className="fas fa-download"></i> Télécharger model EXCEL
                  </button>
                </div>
                <div class="card-body mt-0 pt-0">
                  <div className="row">
                    <div className="col-md-6 d-flex mt-1 pt-2">
                      <div
                        className="p-3 d-flex justify-content-between align-items-center flex-grow-1"
                        style={{ flexGrow: 1 }}
                      >
                        <input
                          style={{
                            border: "1px solid hsl(0, 0%, 80%)",
                            width: "100%" 
                          }}
                          type="file"
                          accept=".xlsx, .xls"
                          className="btn float-right"
                          onChange={handleFileUpload} // Handle file selection
                        />
                      </div>
                    </div>
                  </div>
                </div>
               
                <div className="card-footer">
                  <div className="p-3 d-flex justify-content-end align-items-center">
                    
                    <button
                      className="btn btn-dark float-end"
                      onClick={handleAjouter} // Upload file
                      title="Ajouter cette liste"
                      aria-label="Ajouter cette liste"
                      disabled={isUploading} // Disable button while uploading
                    >
                      <i className="fas fa-location-arrow" aria-hidden="true"></i> Ajouter cette liste
                    </button>
                  </div>
                </div>
                
              </div>
              {notAdded && notAdded.length > 0 && (
                <div className="card-footer">
                  <div className="p-3 ">
                    <h4>Liste des salaires non ajoutés</h4>
                    <div className=" my-0 py-0">
                      <p>{notAdded.join(', ')}</p>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </section>

      <section className="content ">
        {/* card de filtrage  */}
        <div className="card mx-2">
          <div className="row">
            <div className="col-md-12 ">
              <div className="row">
                <div className="col-md-3 my-4 mx-5 ">
                  <div className="form-group">
                    <select
                      className="custom-select form-control-border"
                      name="idContractType"
                      value={formData.idContractType}
                      onChange={handleInputChange}
                    >
                      <option value="contrat">
                        --Filtrage par Type de contrat--
                      </option>
                      {contracttypeNames &&
                        contracttypeNames.map((contracttypeName) => (
                          <option
                            key={contracttypeName.id}
                            value={contracttypeName.id}
                          >
                            {contracttypeName.nomContrat}
                          </option>
                        ))}
                    </select>
                  </div>
                </div>
                <div className="col-md-3 my-4 mx-5">
                  <div className="form-group">
                    <select
                      className="custom-select form-control-border"
                      name="idPost"
                      value={formData.idPost}
                      onChange={handleInputChange}
                    >
                      <option value="post">--Filtrage par Post--</option>
                      {postNames &&
                        postNames.map((postName) => (
                          <option key={postName.id} value={postName.id}>
                            {postName.nomPost}
                          </option>
                        ))}
                    </select>
                  </div>
                </div>

                <div className="col-md-3 my-4 mx-5">
                  <div className="form-group">
                    <select
                      className="custom-select form-control-border"
                      name="mode_paiement"
                      value={formData.mode_paiement}
                      onChange={handleInputChange}
                    >
                      <option value="mP">
                        --Filtrage par Mode de paiement--
                      </option>
                      <option value="espéce">Espéce</option>
                      <option value="chéque">Chéque</option>
                      <option value="virementBoncaire">
                        Virement boncaire
                      </option>
                    </select>
                  </div>
                </div>
                <div className="col-md-5  mx-5 ">
                  <label htmlFor="date_rec">Entre:</label>
                  <div className="form-group">
                    <input
                      className="form-control"
                      type="date"
                      id="date_rec"
                      name="dateDeb"
                      value={formData.dateDeb}
                      onChange={handleInputChange}
                    />
                  </div>
                </div>
                <div className="col-md-5 mx-5 ">
                  <label htmlFor="date_rec">Et:</label>
                  <div className="form-group">
                    <input
                      className="form-control"
                      type="date"
                      id="date_rec"
                      name="dateFin"
                      value={formData.dateFin}
                      onChange={handleInputChange}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

      
        {/*Fin card de filtrage  */}
        <div className="row">
          <div className="col-md-12">
            <div className="card mx-2">
              <div className="container-fluid">
                <div className="row">
                  <div className="card-header col-md-6 left">
                    <h3 className="card-title">Liste des contrats</h3>
                  </div>
                </div>
              </div>
              <div className="card-body">
                <ToolkitProvider
                  keyField="id"
                  data={contracts}
                  columns={columns}
                  exportCSV={{
                    fileName: "List Contrats.csv",
                    onlyExportFiltered: true,
                    exportAll: false,
                  }}
                  search
                >
                  {(props) => (
                    <BootstrapTable
                      {...props.baseProps}
                      data={filteredData}
                      columns={columns}
                      pagination={paginationFactory(options)}
                    />
                  )}
                </ToolkitProvider>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default withLoader(ContractList);
